import { usePageView, useTimeOnPage } from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';

import React from 'react';
import BaseContact from './component/BaseContact';
// 容器组件
const Contact: React.FC = () => {
  // 埋点
  usePageView(FRIDAYAGENT_EVENTS.WEB_TEAMS_PAGEVIEW_CONTACT);
  useTimeOnPage(FRIDAYAGENT_EVENTS.WEB_TEAMS_TIMEONPAGE_CONTACT);

  return (
    <BaseContact/>
  );
};

export default Contact;
